import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import loader from "../../methods/loader";
import ApiClient from "../../methods/api/apiClient";
import methodModel from "../../methods/methods";

export default function CancelPayment() {
  const id = methodModel.getPrams("id");
  const status = methodModel.getPrams("status");
  const type = methodModel.getPrams("type");
  const history = useNavigate();

  const [message, setMessage] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [isAlreadyProcessed, setIsAlreadyProcessed] = useState(false);
  const [showPoInput, setShowPoInput] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [visible, setVisible] = useState(false);

  const getMessgae = (po_number = "") => {
    let url = "request-quote/customer/status/change";
    if (type === "quickbookEstimate") {
      url = "quickbook/update/estimate/status";
    }
    const payload = { id, status, po_number };
    loader(true);
    ApiClient.get(url, payload).then((res) => {
      if (res) {
        const msg = res?.error?.message || res?.message || "";
        setMessage(msg);
        const lower = msg.toLowerCase();
        if (
          lower.includes("already accepted") ||
          lower.includes("already rejected")
        ) {
          setIsAlreadyProcessed(true);
          setShowPoInput(false);
        }
        setSubmitted(true);
      }
      loader(false);
    });
  };

  useEffect(() => {
    if (status === "accept") {
      setShowPoInput(true);
    } else {
      getMessgae();
    }
    setTimeout(() => setVisible(true), 50);
  }, []);

  const handleSkip = () => {
    setShowPoInput(false);
    getMessgae("");
  };

  const handleSubmitPO = () => {
    setShowPoInput(false);
    getMessgae(poNumber);
  };

  const isAccepted = status === "accept";
  const isCancelled = status === "cancel" || status === "reject";

  return (
    <section className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 flex items-center justify-center px-4 py-16">
      {/* Background grid decoration */}
      <div className="fixed inset-0 bg-[linear-gradient(rgba(17,91,157,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(17,91,157,0.03)_1px,transparent_1px)] bg-[size:48px_48px] pointer-events-none" />

      <div
        className={`relative z-10 w-full max-w-lg transition-all duration-700 ease-out ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        {/* Top accent bar */}
        <div
          className={`h-1 w-full rounded-t-3xl ${
            showPoInput
              ? "bg-gradient-to-r from-blue-500 to-cyan-400"
              : isAccepted
                ? "bg-gradient-to-r from-emerald-400 to-teal-500"
                : isCancelled
                  ? "bg-gradient-to-r from-rose-400 to-red-500"
                  : "bg-gradient-to-r from-blue-500 to-indigo-500"
          }`}
        />

        <div className="bg-white rounded-b-3xl rounded-tr-3xl shadow-[0_8px_60px_rgba(17,91,157,0.12)] border border-slate-100 p-8 md:p-10">
          {/* ── PO NUMBER INPUT STATE ── */}
          {showPoInput && (
            <div className="text-center">
              {/* Icon */}
              <div className="w-16 h-16 rounded-2xl bg-blue-50 border border-blue-100 flex items-center justify-center mx-auto mb-6">
                <svg
                  className="w-8 h-8 text-blue-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={1.5}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
                  />
                </svg>
              </div>

              <h2 className="text-2xl font-700 text-slate-800 mb-1 font-semibold">
                Accept Estimate
              </h2>
              <p className="text-slate-500 text-sm mb-8 leading-relaxed">
                You're about to accept this estimate. Optionally enter a PO
                number for your records — you can skip this step.
              </p>

              {/* PO Input */}
              <div className="text-left mb-3">
                <label className="block text-xs font-semibold text-slate-500 uppercase tracking-widest mb-2">
                  PO Number
                  <span className="ml-2 text-blue-400 normal-case tracking-normal font-normal">
                    (Optional)
                  </span>
                </label>
                <div className="relative">
                  <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                      />
                    </svg>
                  </span>
                  <input
                    type="text"
                    value={poNumber}
                    onChange={(e) => setPoNumber(e.target.value)}
                    placeholder="e.g. PO-2024-00123"
                    className="w-full pl-11 pr-4 py-3.5 rounded-xl border border-slate-200 bg-slate-50 text-slate-700 placeholder-slate-400 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white transition-all duration-200"
                    onKeyDown={(e) => e.key === "Enter" && handleSubmitPO()}
                  />
                </div>
              </div>

              <p className="text-xs text-slate-400 text-left mb-8">
                Press{" "}
                <kbd className="px-1.5 py-0.5 bg-slate-100 border border-slate-200 rounded text-slate-500 font-mono text-xs">
                  Enter
                </kbd>{" "}
                or click confirm to proceed.
              </p>

              {/* Actions */}
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={handleSkip}
                  className="flex-1 px-5 py-3 rounded-xl border border-slate-200 text-slate-600 text-sm font-medium hover:bg-slate-50 hover:border-slate-300 transition-all duration-200 active:scale-95"
                >
                  Skip for now
                </button>
                <button
                  onClick={handleSubmitPO}
                  className="flex-1 px-5 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-blue-500 text-white text-sm font-semibold shadow-[0_4px_14px_rgba(17,91,157,0.35)] hover:shadow-[0_6px_20px_rgba(17,91,157,0.45)] hover:-translate-y-0.5 transition-all duration-200 active:scale-95"
                >
                  Confirm & Accept
                </button>
              </div>
            </div>
          )}

          {/* ── RESULT STATE ── */}
          {!showPoInput && submitted && (
            <div className="text-center">
              {/* Status Icon */}
              <div
                className={`w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6 ${
                  isAlreadyProcessed
                    ? "bg-amber-50 border border-amber-100"
                    : isAccepted
                      ? "bg-emerald-50 border border-emerald-100"
                      : isCancelled
                        ? "bg-rose-50 border border-rose-100"
                        : "bg-blue-50 border border-blue-100"
                }`}
              >
                {isAlreadyProcessed ? (
                  <svg
                    className="w-8 h-8 text-amber-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.5}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                    />
                  </svg>
                ) : isAccepted ? (
                  <svg
                    className="w-8 h-8 text-emerald-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.5}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                ) : isCancelled ? (
                  <svg
                    className="w-8 h-8 text-rose-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.5}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                ) : (
                  <svg
                    className="w-8 h-8 text-blue-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.5}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                    />
                  </svg>
                )}
              </div>

              {/* Status Badge */}
              <div className="flex justify-center mb-4">
                <span
                  className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider ${
                    isAlreadyProcessed
                      ? "bg-amber-50 text-amber-600 border border-amber-200"
                      : isAccepted
                        ? "bg-emerald-50 text-emerald-600 border border-emerald-200"
                        : isCancelled
                          ? "bg-rose-50 text-rose-600 border border-rose-200"
                          : "bg-blue-50 text-blue-600 border border-blue-200"
                  }`}
                >
                  <span
                    className={`w-1.5 h-1.5 rounded-full ${
                      isAlreadyProcessed
                        ? "bg-amber-400"
                        : isAccepted
                          ? "bg-emerald-400"
                          : isCancelled
                            ? "bg-rose-400"
                            : "bg-blue-400"
                    }`}
                  />
                  {isAlreadyProcessed
                    ? "Already Processed"
                    : isAccepted
                      ? "Accepted"
                      : isCancelled
                        ? "Rejected"
                        : "Updated"}
                </span>
              </div>

              <h2 className="text-xl font-semibold text-slate-800 mb-2 leading-snug">
                {methodModel.capitalizeFirstLetter(message)}
              </h2>
              <p className="text-slate-400 text-sm mb-8">
                {isAccepted && !isAlreadyProcessed
                  ? "Your estimate has been accepted successfully."
                  : isCancelled && !isAlreadyProcessed
                    ? "Your request has been rejected."
                    : "You can continue browsing our products below."}
              </p>

              {/* PO Number display if entered */}
              {poNumber && isAccepted && !isAlreadyProcessed && (
                <div className="flex items-center gap-3 bg-slate-50 border border-slate-100 rounded-xl px-4 py-3 mb-6 text-left">
                  <svg
                    className="w-4 h-4 text-slate-400 shrink-0"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                    />
                  </svg>
                  <div>
                    <p className="text-xs text-slate-400 font-medium uppercase tracking-wider">
                      PO Number
                    </p>
                    <p className="text-sm text-slate-700 font-mono font-medium">
                      {poNumber}
                    </p>
                  </div>
                </div>
              )}

              <button
                onClick={() => history("/products")}
                className="w-full px-6 py-3.5 rounded-xl bg-gradient-to-r from-[#115B9D] to-[#116DAE] text-white text-sm font-semibold shadow-[0_4px_14px_rgba(17,91,157,0.3)] hover:shadow-[0_6px_20px_rgba(17,91,157,0.4)] hover:-translate-y-0.5 transition-all duration-200 active:scale-95 flex items-center justify-center gap-2"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
                  />
                </svg>
                Continue Shopping
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
